// extracted by mini-css-extract-plugin
export default {"sectionLayout":"SectionLayout_sectionLayout__sw43+"};